export default class NewPassword {
    public password: string;
    public resetPasswordId: string;
}
